import React from 'react'
import CurrencyTypeView from '../../../../../itrust_common/components/others/CurrencyTypeView'

export default function EyeglassLenses(props) {
  const { glass } = props

  const getEyeType = (eye_type) => {
    return eye_type == 'od' ? 'OD' : 'OS'
  }

  const handleLensPrint = (lens) => {
    return (
      <tr className="text-dark bg-light border-bottom border-white border-bottom-2">
        <td> {lens.eye_type ? getEyeType(lens.eye_type) : ''} Glass Lens Type</td>
        <td>{lens.name}</td>
        <td className="pl-8">{lens.unit_price ? <CurrencyTypeView amount={lens.unit_price} /> : ''}</td>
        <td>{lens.copay ? <CurrencyTypeView amount={lens.copay} /> : ''}</td>
        <td>{(lens.cash_discount || lens.percentage_discount) ? <CurrencyTypeView amount={lens.discount_type === "cash" ? lens.cash_discount : lens.percentage_discount} /> : ''}</td>
        <td colSpan="3">{lens.subtotal ? <CurrencyTypeView amount={lens.subtotal} /> : ''}</td>
      </tr>
    )
  }

  return (
    <>
      {glass.lens_types_attributes?.map(lens => handleLensPrint(lens))}
    </>
  )
}
